import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import withMessages, { FormattedMessage } from 'component-utilities/intl';
import LoadingIndicator from 'v-c/LoadingIndicator';

import DocumentViewerAssetNotFound from './DocumentViewerAssetNotFound';

import styles from './DocumentViewer.scss';

const BASE_KEY = 'components.document_viewer';

function DocumentViewerBodyComponent(props) {
    return (<div className={styles['dv-body']}>
        {!!props.documentIndex && (
            <div className={styles['dv-left']}>
                <span
                    role="presentation"
                    className={styles['btn-previous']}
                    onClick={props.onPrev}
                    title={props.getMessage(`${BASE_KEY}.previous_attachment`)}
                />
            </div>
        )}
        <div className={styles['dv-middle']}>
            <div className={styles['dv-document']} style={{ width: `${props.bodyWidth}%` }}>
                {!props.isLoaded && !props.loadingFailed && <LoadingIndicator white isLoading />}
                {props.loadingFailed && <DocumentViewerAssetNotFound getMessage={props.getMessage} />}
                <iframe
                    onLoad={props.onLoadContent}
                    id="attachment-rendered-view"
                    src={props.url}
                    title="rendered-view"
                    data-document-viewer
                    width="100%"
                    height="100%"
                    name="rendered-view"
                    style={{ visibility: props.isLoaded ? 'visible' : 'hidden' }}
                />
            </div>
            {props.isControlsEnabled && (
                <span className={styles['dv-doc-controls']}>
                    <span className={styles['dv-pages']}>
                        <FormattedMessage
                            id={`${BASE_KEY}.page_info`}
                            values={{
                                pageIndex: props.pageIndex.toString(),
                                total: props.pagesTotal,
                            }}
                        />
                    </span>
                    <span className={styles['dv-zoom']}>
                        <span
                            role="presentation"
                            className={styles['btn-minus']}
                            onClick={props.onZoom('minus')}
                            title={props.getMessage(`${BASE_KEY}.zoom_out`)}
                        />
                        <span
                            role="presentation"
                            className={styles['btn-magnify']}
                            onClick={props.onZoom('default')}
                            title={props.getMessage(`${BASE_KEY}.zoom`)}
                        />
                        <span
                            role="presentation"
                            className={styles['btn-plus']}
                            onClick={props.onZoom('plus')}
                            title={props.getMessage(`${BASE_KEY}.zoom_in`)}
                        />
                    </span>
                </span>
            )}
        </div>
        {props.documentIndex + 1 !== props.documentsTotal && (
            <div className={styles['dv-right']}>
                <span
                    role="presentation"
                    className={styles['btn-next']}
                    onClick={props.onNext}
                    title={props.getMessage(`${BASE_KEY}.next_attachment`)}
                />
            </div>
        )}
    </div>)
}

DocumentViewerBodyComponent.propTypes = {
    onNext: PropTypes.func.isRequired,
    onPrev: PropTypes.func.isRequired,
    onZoom: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
    documentIndex: PropTypes.number.isRequired,
    documentsTotal: PropTypes.number.isRequired,
    pageIndex: PropTypes.number.isRequired,
    pagesTotal: PropTypes.number.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    bodyWidth: PropTypes.number.isRequired,
    getMessage: PropTypes.func.isRequired,
    loadingFailed: PropTypes.bool.isRequired,
    onLoadContent: PropTypes.func.isRequired,
    isControlsEnabled: PropTypes.bool,
};

DocumentViewerBodyComponent.defaultProps = {
    isControlsEnabled: false,
};

const DocumentViewerBody = withMessages(DocumentViewerBodyComponent);
DocumentViewerBody.displayName = displayName('DocumentViewer/DocumentViewerBody');

export default DocumentViewerBody;
